<template>
  <v-row
    no-gutters
    class=" align-center element justify-space-between flex-nowrap"
    :class="classes"
    :style="{ 'background-color': backgroundColor }"
  >
    <v-col class="handleDrag">
      <v-row no-gutters class="flex-nowrap align-center">
        <v-col cols="auto" v-if="level > 1 || isRight">
          <img
            v-if="layerStyle && layerStyle.externalGraphic"
            width="20px"
            height="20px"
            :src="getIcon(layerStyle.externalGraphic)"
            class="ml-1 mt-2"
          />
          <legend-layer-list-icon
            v-else
            :color="getIconColor(layerStyle)"
            :layer-type="getLayerType(layer)"
          ></legend-layer-list-icon>
        </v-col>
        <v-col cols="auto">
          <div
            class="text-truncate text-body-2 flex-shrink-0"
            :class="{ 'pl-2': level > 1 || isRight, 'text--disabled': disabled }"
            style="padding-top: 2px;"
          >
            {{ name }}
          </div>
        </v-col>
      </v-row>
      <div></div>
    </v-col>
    <v-col cols="auto">
      <dots-menu
        :disabled="disabled"
        font-size="19px"
        :items="computedDotsItems"
        @manageCard="$emit('manageCard', $props)"
        @changeGroupName="$emit('changeGroupName', $props)"
        @manageLayer="$emit('manageLayer', $props, layer)"
        @deleteFromSystem="$emit('deleteFromSystem', $props)"
        @delete="$emit('delete', $props)"
        @changeSymbolization="$emit('changeSymbolization', $props)"
      >
      </dots-menu>
    </v-col>
  </v-row>
</template>

<script>
import { get } from 'vuex-pathify';
import DotsMenu from '@/components/DotsMenu';
import LegendLayerListIcon from '@/components/LegendLayerListIcon';

export default {
  name: 'DraggableListsLayersItem',
  components: {
    DotsMenu,
    LegendLayerListIcon,
  },
  props: {
    // element: {
    //   required: true,
    //   type: Array,
    // },
    type: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    isRight: {
      type: Boolean,
      default: false,
    },
    level: {
      type: Number,
      required: true,
    },
    dotsItems: {
      type: Array,
      default: () => [
        {
          name: 'manageLayer',
        },
        {
          name: 'manageCard',
        },
        {
          name: 'changeSymbolization',
        },
        {
          name: 'deleteFromSystem',
        },
      ],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    role: {
      type: String,
      default: '',
    },
  },
  computed: {
    layer: get('layers/layers@:id'),
    layerStyle() {
      if (this.layer) {
        return this.layer.style_web;
      }
      return undefined;
    },
    classes() {
      if (this.isRight) {
        return ['border', 'px-4'];
      }
      return this.level > 1 ? [`px-${this.level * 2}`, 'border'] : [];
    },
    backgroundColor() {
      return this.level > 1 ? 'rgb(231, 231, 231, 0.5)' : 'white';
    },
    computedDotsItems() {
      let dotsItems = JSON.parse(JSON.stringify(this.dotsItems));
      if (this.type === 'service_layer') {
        dotsItems = dotsItems.filter(item => item.name !== 'changeSymbolization' && item.name !== 'manageCard');
      }
      if (this.role) {
        dotsItems = dotsItems.filter(item => item.name !== 'deleteFromSystem');
      }
      return dotsItems;
    },
  },
  methods: {
    getLayerType(layer) {
      return layer.type === 'features_layer' ? layer.geometry_type : layer.service_type;
    },
    getIconColor(style) {
      if (style) {
        return style['fill-color'] || style['circle-color'] || style['line-color'] || 'green';
      } else {
        return 'grey';
      }
    },
    getIcon(name) {
      return `${process.env.VUE_APP_API_URL}/icons/${name}`;
    },
  },
};
</script>

<style scoped lang="scss">
ul {
  padding-left: 0;
  list-style: none;
}
.element {
  height: 40px;
}
.border {
  margin-bottom: 4px;
  @include border(top);
  @include border(right);
  @include border(left);
  &:last-child {
    @include border(bottom);
  }
}
</style>
